export default __webpack_public_path__ + "static/media/sec-3-btm.f14234ff.svg";